// *** Storage constants ***
const VERIFY_STORAGE = "verify";
const TOKENS_STORAGE = "tokens";
const USER_INFO_STORAGE = "userInfo";

// *** Export storage constants ***
export { TOKENS_STORAGE, VERIFY_STORAGE, USER_INFO_STORAGE };
